var server = {
	// Get the API url
	getUrl() {
		var isLocal = (window.location.href.indexOf("localhost") >= 0);
		var url = "https://survey.hakosalo.fi/API"; //Tähän API tuotanto-osoite
		if (isLocal) {
			url = "http://localhost:5000";
		}

		return url;
	},

	makeUrl(endpoint) {
		if (endpoint[0] != "/") {
			endpoint = "/" + endpoint;
		}
		return this.getUrl() + endpoint;
	}
}

export default server;